var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7284 3.88384C17.1627 2.44395 19.2608 2.41371 20.4222 3.57968C21.5859 4.74786 21.5546 6.8591 20.1193 8.29997L17.6954 10.7332C17.4031 11.0266 17.404 11.5015 17.6975 11.7938C17.9909 12.0862 18.4658 12.0852 18.7581 11.7918L21.182 9.35857C23.0933 7.43986 23.3332 4.37653 21.485 2.52108C19.6345 0.663429 16.5779 0.905542 14.6657 2.82524L9.81802 7.6917C7.90672 9.61041 7.66677 12.6737 9.51503 14.5292C9.80736 14.8226 10.2822 14.8236 10.5757 14.5312C10.8692 14.2389 10.8701 13.764 10.5777 13.4706C9.41409 12.3024 9.44543 10.1911 10.8807 8.7503L15.7284 3.88384Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4849 9.4707C14.1926 9.17724 13.7177 9.17632 13.4243 9.46864C13.1308 9.76097 13.1299 10.2358 13.4222 10.5293C14.5859 11.6975 14.5545 13.8087 13.1192 15.2496L8.27162 20.1161C6.8373 21.5559 4.73922 21.5862 3.57775 20.4202C2.41409 19.252 2.44543 17.1408 3.88074 15.6999L6.30458 13.2666C6.5969 12.9732 6.59598 12.4983 6.30252 12.206C6.00906 11.9136 5.53419 11.9146 5.24187 12.208L2.81802 14.6413C0.906723 16.56 0.666764 19.6234 2.51504 21.4788C4.36551 23.3365 7.42206 23.0944 9.33434 21.1747L14.182 16.3082C16.0933 14.3894 16.3332 11.3261 14.4849 9.4707Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.d23ea4c0e98f39c91a107f5ae8260379.svg";
export { ForwardRef as ReactComponent };